import { useSettings } from "@/context/SettingsContext";
import { trackClick } from "@/lib/api";
import { MessageCircle } from "lucide-react";

export default function WhatsAppFloat() {
  const s = useSettings();
  return (
    <a
      href={s.whatsapp_url}
      target="_blank"
      rel="noopener"
      onClick={() => trackClick("whatsapp")}
      data-testid="whatsapp-float"
      aria-label="Hai bisogno di aiuto? Contattaci su WhatsApp"
      className="fixed bottom-4 right-4 sm:bottom-6 sm:right-6 z-40 group flex items-center gap-3 pl-4 pr-5 py-3 rounded-full bg-yellow-400 text-black font-bold shadow-2xl animate-vinko-pulse transition-transform duration-200 hover:scale-105"
    >
      <MessageCircle className="w-5 h-5" />
      <span className="hidden sm:inline text-sm">Hai bisogno di aiuto?</span>
    </a>
  );
}
